<template>
        <div class="page-container">
            <VueGallery :images="images" :index="index" @close="index = null"></VueGallery>

            <div>
                <Header
                    :languages="languages"
                    :items="menuItems"></Header>
                <vue-progress-bar></vue-progress-bar>
                <div class="container is-fluid up-margin">
                    <div class="columns is-variable is-1">
                        <main :class="[$route.name == 'homepage' ? 'column is-variable is-10-desktop is-fullwidth-touch' : 'column is-variable is-10-desktop is-fullwidth-touch']">
                            <div class="box is-opacity-90 shadow">
                                <router-view></router-view>
                            </div>
                        </main>
                        <div class="column is-variable is-2-desktop is-hidden-touch float">
                            <div 
                                :class="[$route.name == 'homepage' ? 'box is-opacity-70 shadow' : 'box is-opacity-90 shadow']">
                                <Menu 
                                    :languages="languages"
                                    :items="menuItems"
                                ></Menu>
                            </div>
                        </div>
                    </div>
                </div>
                <br>
            </div>

            <b-modal :active.sync="isGalleryModalActive"
                :can-cancel="[]">
                <GalleryModal
                    :gallery="gallery">
                </GalleryModal>
            </b-modal>
        </div>
</template>
<script>    
    import VueGallery from "vue-gallery";
    import EventBus from "../event-bus.js";

    import Header from "./includes/Header"
    import Menu from "./includes/Menu"
    import GalleryModal from "./includes/GalleryModal"


    export default {
        data(){
            return {
                isGalleryModalActive: false,
                gallery: null,
                index: null,
                images: null,

                languages: [
                    "hu",
                    "rs"
                ],
                menuItems: [
                    "homepage",
                    "news",
                    "history",
                    "about_us",
                    "gallery",
                    "documents",
                    "contact"
                ]
            }
        },
        components: {
            Header,
            Menu,
            GalleryModal,
            VueGallery
        },
        mounted() {
            EventBus.$on("openGalleryModal", (gallery) => {
                this.isGalleryModalActive = true
                this.gallery = gallery
            })
            EventBus.$on("openGallery", (images, index) => {
                this.images = images
                this.index = index
            })
        },
    }
</script>
<style lang="scss">
    $primary: #123456;
    $primary-invert: findColorInvert($primary);
</style>